import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  class: "title"
}
const _hoisted_4 = {
  key: 1,
  class: "title"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "body" }
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "col-sm-6" }
const _hoisted_13 = { class: "col-sm-6" }
const _hoisted_14 = { class: "text-center mt-5" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.localModel.identifier)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_localized_text, {
              localizedKey: "Edit Customer",
              text: "Edit Customer"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_localized_text, {
              localizedKey: "Create Customer",
              text: "Create Customer"
            })
          ])),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_form_field, {
              type: "text",
              labelKey: "Email",
              labelValue: "Email",
              placeholderKey: "Email",
              placeholderValue: "Email",
              modelValue: _ctx.localModel.username,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localModel.username) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_form_field, {
              type: "password",
              labelKey: "Password",
              labelValue: "Password",
              placeholderKey: "Password",
              placeholderValue: "Password",
              modelValue: _ctx.localModel.password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModel.password) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_form_field, {
              type: "select",
              labelKey: "Company",
              labelValue: "Company",
              placeholderKey: "Company",
              placeholderValue: "Company",
              list: _ctx.companyList,
              modelValue: _ctx.model.company.identifier,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.company.identifier) = $event))
            }, null, 8, ["list", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_form_field, {
              type: "select-string",
              labelKey: "Language",
              labelValue: "Language",
              placeholderKey: "Language",
              placeholderValue: "Language",
              list: _ctx.$store.state.consts.enabledLanguages,
              modelValue: _ctx.model.preferredCulture,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.preferredCulture) = $event))
            }, null, 8, ["list", "modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          disabled: _ctx.disabled,
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          (!_ctx.localModel.identifier)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Create Customer",
                  text: "Create Customer"
                })
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_17, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Edit Customer",
                  text: "Edit Customer"
                })
              ]))
        ], 8, _hoisted_15)
      ])
    ])
  ]))
}